export const zIndexes = {
    anchoredPopover: 110,
    dialog: 100,
    select: 110,
    tableRowHeader: 50,
    tableStickyColumn: 1,
    stickyContainer: 75,
    combobox: 60,
    datepicker: 100,
    tooltip: 110,
};
